import { useState } from 'react';
import { css } from 'styled-components';
import { getDynamicPlacement, getPseudoLeftPos, getPseudoStyle, getPseudoTopPos, getTooltipTransform } from './utils';
export default function usePlacement() {
  const sideArrowOffset = 14;
  const [_css, setCSS] = useState();

  const setContent = (anchorRef, tooltipRef, placement, arrowSize, border, offset, title, titleBackground, message, messageBackground) => {
    if (!title && !message) return;
    const bestPlacement = getDynamicPlacement(anchorRef, tooltipRef, placement);
    const tooltipCSS = /*#__PURE__*/css(["transform:", ";&::before,&::after{content:'';position:absolute;filter:drop-shadow(0 3px 5px #666666);", ";top:", ";left:", ";}"], getTooltipTransform(anchorRef, arrowSize, border, sideArrowOffset, offset, bestPlacement), getPseudoStyle(arrowSize, titleBackground, messageBackground, bestPlacement), getPseudoTopPos(arrowSize, sideArrowOffset, bestPlacement), getPseudoLeftPos(arrowSize, sideArrowOffset, bestPlacement));
    setCSS(tooltipCSS);
  };

  return [_css, setContent];
}